import { ApiService } from '../api.service';
var AppHeartBeatService = (function () {
    function AppHeartBeatService(apiService) {
        this.apiService = apiService;
    }
    //设置需要传递的心跳参数(心跳参数/定位信息/pathname)
    AppHeartBeatService.prototype.setHeartBeatValue = function (data, sourceData) {
        data['appName'] = window['appName'] ? window['appName'] : ""; //appName
        data['appVersion'] = window['version'] ? window['version'] : ""; //版本
        data['userId'] = sourceData.userId ? sourceData.userId : ""; //用户Id
        data['actionId'] = "1000"; //心跳Id
        data['actionContext'] = ""; //心跳上下文
        data['learningPathMetaId'] = sourceData.learningPathMetaId ? sourceData.learningPathMetaId : "";
        data['objectIds'] = []; //心跳Action Value
        // data['objectIds'][0] = {};
        // data['objectIds'][0]['routeUrl'] = this.platformLocation['location']['pathname'] ? this.platformLocation['location']['pathname'] : "";
        data['objectIds'][0] = sourceData.pathname ? sourceData.pathname : "";
        data['objectIds'][1] = sourceData.moduleId;
        data['result'] = ""; //结果
        data['clientInfo'] = {}; //客户端信息
        data['clientInfo']['timeOpened'] = new Date().getTime(); //客户端时间戳
        data['clientInfo']['timezone'] = new Date().getTimezoneOffset(); //本地时间与 GMT 时间之间的时间差
        data['clientInfo']['pageon'] = sourceData.pathname ? sourceData.pathname : ""; //当前停留页面
        data['clientInfo']['referrer'] = document.referrer ? document.referrer : ""; //来源
        data['clientInfo']['previousSites'] = history.length ? history.length : 0; //之前的站点数量
        data['clientInfo']['browserName'] = navigator.appName ? navigator.appName : ""; //浏览器名称
        data['clientInfo']['browserEngine'] = navigator.product ? navigator.product : ""; //浏览器引擎
        data['clientInfo']['browserVersion1a'] = navigator.appVersion ? navigator.appVersion : ""; //浏览器版本信息
        data['clientInfo']['browserVersion1b'] = navigator.userAgent ? navigator.userAgent : ""; //用户代理
        data['clientInfo']['browserLanguage'] = navigator.language ? navigator.language : ""; //浏览器语言
        data['clientInfo']['browserOnline'] = navigator.onLine ? navigator.onLine : false; //浏览器是否在线
        data['clientInfo']['browserPlatform'] = navigator.platform ? navigator.platform : ""; //浏览器平台
        data['clientInfo']['javaEnabled'] = navigator.javaEnabled(); //浏览器是否支持并启用了 Java
        data['clientInfo']['dataCookies'] = []; //浏览器cookies
        for (var i = 0, len = document.cookie.split(';').length; i < len; i += 1) {
            data['clientInfo']['dataCookies'].push(decodeURIComponent(document.cookie.split(';')[i]));
        }
        data['clientInfo']['timestamp'] = Date.now();
        data['clientInfo']['sizeScreenW'] = screen.width ? screen.width : 0; //浏览器的屏幕的宽度
        data['clientInfo']['sizeScreenH'] = screen.height ? screen.height : 0; //浏览器的屏幕的高度
        data['clientInfo']['sizeDocW'] = document.documentElement.clientWidth ? document.documentElement.clientWidth : 0; //页面可视区的宽度
        data['clientInfo']['sizeDocH'] = document.documentElement.clientHeight ? document.documentElement.clientHeight : 0; //页面可视区的高度
        data['clientInfo']['sizeInW'] = window.innerWidth ? window.innerWidth : 0; //文档显示区的宽度
        data['clientInfo']['sizeInH'] = window.innerHeight ? window.innerHeight : 0; //文档显示区的高度
        data['clientInfo']['sizeAvailW'] = screen.availWidth ? screen.availWidth : 0; //浏览器的屏幕的可用宽度
        data['clientInfo']['sizeAvailH'] = screen.availHeight ? screen.availHeight : 0; //浏览器的屏幕的可用高度
        data['clientInfo']['scrColorDepth'] = screen.colorDepth ? screen.colorDepth : 0; //设备调色板比特深度
        data['clientInfo']['scrPixelDepth'] = screen.pixelDepth ? screen.pixelDepth : 0; //屏幕色彩分辨率
        // data['clientInfo']['latitude'] = sourceData.geolocation ? sourceData.geolocation.coords.latitude.toString() : ""; //纬度
        // data['clientInfo']['longitude'] = sourceData.geolocation ? sourceData.geolocation.coords.longitude.toString() : ""; //经度
        // data['clientInfo']['accuracy'] = sourceData.geolocation ? sourceData.geolocation.coords.accuracy.toString() : ""; //精准度
        // data['clientInfo']['altitude'] = sourceData.geolocation ? sourceData.geolocation.coords.altitude.toString() : ""; //海拔
        // data['clientInfo']['altitudeAccuracy'] = sourceData.geolocation ? sourceData.geolocation.coords.altitudeAccuracy.toString() : ""; //海拔精准度
        // data['clientInfo']['heading'] = sourceData.geolocation ? sourceData.geolocation.coords.heading.toString() : ""; //方向
        // data['clientInfo']['speed'] = sourceData.geolocation ? sourceData.geolocation.coords.speed.toString() : ""; //速度
        // data['clientInfo']['timestamp'] = sourceData.geolocation ? sourceData.geolocation.timestamp.toString() : Date.now(); //相应时间
    };
    AppHeartBeatService.prototype.getEnvironmentsAppId = function (host) {
        var testAppId = "1739e28a7bc100";
        var hostMap = {
            'm.transtalent.cn': '1739e28a7bc179',
            'm-cdn.transtalent.cn': '1739e28a7bc179',
            'play.yunxuetang.cn': '1739e28a7bc179',
            'm2.yunxuetang.cn': '1739e28a7bc179',
            'm-dev.transtalent.cn': "1739e28a7bc100"
        };
        return hostMap[host] || testAppId; //如果匹配不到则默认为测试环境APPID
    };
    //获取环境对应的请求url
    AppHeartBeatService.prototype.getEnvironmentsUrl = function (host) {
        var protocol = location['protocol'];
        var testApiAddress = protocol + "//lrs-pre.transtalent.cn";
        var hostMapApiAddress = {
            'm.transtalent.cn': protocol + '//lrs.transtalent.cn',
            'play.yunxuetang.cn': protocol + '//lrs.transtalent.cn',
            'm2.yunxuetang.cn': protocol + '//lrs.transtalent.cn',
            'm-dev.transtalent.cn': protocol + "//lrs-test.transtalent.cn",
            'localhost:4200': protocol + "//lrs-test.transtalent.cn",
            'm-1.transtalent.cn': protocol + "//lrs-pre.transtalent.cn",
            'm-uat.transtalent.cn': protocol + "//lrs-uat.transtalent.cn",
            'm-uat-cdn.transtalent.cn': protocol + "//lrs-uat.transtalent.cn",
            'm-cdn.transtalent.cn': protocol + '//lrs.transtalent.cn'
        };
        return hostMapApiAddress[host] || testApiAddress; //如果匹配不到则默认为测试环境的API地址
    };
    //保存心跳数据
    AppHeartBeatService.prototype.saveHeartBeatValue = function (host, data, url) {
        var _host = host.indexOf('yunxuetang') == -1 ? url + '/v1/heartbeat/' : '/heartbeat/v1/heartbeat/';
        return this.apiService.ajax({
            'type': 'POST',
            'url': _host,
            'data': data
        });
    };
    //获取心跳间隔(appId)
    AppHeartBeatService.prototype.getHeartBeatDuration = function (host, appId, url) {
        var _host = host.indexOf('yunxuetang') == -1 ? url + '/v1/configuration/' + appId : '/heartbeat/v1/configuration/' + appId;
        return this.apiService.ajax({
            'type': 'GET',
            'url': _host
        }).toPromise();
    };
    //获取定位信息
    AppHeartBeatService.prototype.getLocation = function () {
        var geolocationPromise = new Promise(function (resolve, reject) {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function (position) {
                    resolve(position);
                }, function (error) {
                    reject(error);
                });
            }
            else {
                reject({
                    "code": 1,
                    "message": "当前浏览器不支持geolocation定位"
                });
            }
        });
        return geolocationPromise;
    };
    return AppHeartBeatService;
}());
export { AppHeartBeatService };



// WEBPACK FOOTER //
// ./src/app/app-heart-beat/app-heart-beat.service.ts.pre-build-optimizer.js